

import './Nav.css'
export default function Title(){
    return(
        
        <div id='logo'>
             <p className="the"> The</p> <h1 className='Siren'>Siren</h1>
         </div>   
        
    )
}

